import script from "./sf-checkbox.vue?vue&type=script&setup=true&lang=ts"
export * from "./sf-checkbox.vue?vue&type=script&setup=true&lang=ts"

import "./sf-checkbox.vue?vue&type=style&index=0&id=ffb301e5&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ffb301e5"]])

export default __exports__